import React from 'react';
import { overrideActionFor } from '../../utils/lionAutoOverrides';

// The listing table's Include / Exclude cell for one listing of ours while a
// draft is open: Exclude a member, Include a listing the group doesn't take
// (out of its sections, kept out by a filter, or held by another group),
// Remove include / Undo exclude to hand it back to the filters
// (overrideActionFor). The row's own click ranks it, so the button's click
// stops there. Nothing until the match result says whether it is a member;
// while that result is not current (resultStale), a button it decides waits,
// disabled.
//
// overrides: { includeIds, excludeIds, onToggle(inventoryId, mode) };
// isMember: true / false from the result, null while it is not in;
// listingName: "Sec 112 Row A", so each button's accessible name says which
// listing it acts on.
function LaOverrideButton({ overrides, inventoryId, isMember, resultStale = false, listingName = '' }) {
  const action = overrideActionFor(overrides, { id: inventoryId, isMember, resultStale });
  if (!action) return null;
  const handleClick = (e) => {
    e.stopPropagation();
    overrides.onToggle(inventoryId, action.mode);
  };
  return (
    <button
      type="button"
      className="la-link"
      disabled={action.disabled}
      title={action.title}
      aria-label={listingName ? `${action.label} ${listingName}` : action.label}
      onClick={handleClick}
    >
      {action.label}
    </button>
  );
}

export default LaOverrideButton;
